const app = {
    theme: {
        primary: {
            color: 'red',
            hue: '900',
        },
        accent: {
            color: 'red',
            hue: '500',
        },
        warn: {
            color: 'red',
            hue: 400,
        },
        background: 'white',
    },
    title: 'STSHOP',
};

export default (Vue) => {
    Vue.material.registerTheme('default', app.theme);
};
export const title = app.title;


// WEBPACK FOOTER //
// ./src/config/theme/theme.js